/* PDP reviews — 10 entries, taggable by Anlass for H6 filtering */
window.LENORA_REVIEWS = [
  {
    name: "Nina K.",
    tag: "hochzeit",
    tagLabel: "Hochzeit",
    text: "Hannah hat geweint. Sie hat das Bild aufgehängt, BEVOR sie das Geld rausgenommen hat. Ich hatte den 24. Umschlag auf dem Tisch — am Ende war meiner der einzige, der nicht im Stapel verschwand.",
    meta: "Brautpaar · zur Schwester-Hochzeit verschenkt · 2 Wochen alt"
  },
  {
    name: "Anja M.",
    tag: "kommunion",
    tagLabel: "Kommunion",
    text: "Meine Schwiegermutter wollte wissen, „wo du das gekauft hast“. Bester Moment dieses Jahr. Ich hab ihr Lenora geschickt, jetzt nimmt sie das auch für die Konfi vom Patenkind.",
    meta: "Kommunion-Kreuz · für den Patensohn · 1 Monat alt"
  },
  {
    name: "Katharina B.",
    tag: "konfirmation",
    tagLabel: "Konfirmation",
    text: "Lukas (15!) hat den Rahmen direkt mit in sein Zimmer genommen. Der pubertär-coole hat sich gefreut wie ein Kind. Hätte ich vorher gewusst, hätte ich keinen Umschlag mehr im Haus.",
    meta: "Konfirmation-Fisch · für den Neffen · 3 Wochen alt"
  },
  {
    name: "Marie W.",
    tag: "hochzeit",
    tagLabel: "Hochzeit",
    text: "Ich hab das 3er-Bundle gekauft und JETZT erst gemerkt, wie viele Anlässe dieses Jahr sind. Spar ich mir das nächste Mal die Last-Minute-Bestellungen. Drei Hochzeiten — ein Klick.",
    meta: "3er-Bundle · für Trauzeuginnen-Geschenke · letzte Woche"
  },
  {
    name: "Steffi R.",
    tag: "hochzeit",
    tagLabel: "5er-Bundle",
    text: "Komplette Jahresplanung in einem Klick. Hochzeit Schwester, Konfi Patenkind, Kommunion Neffe, Taufe Cousine, Geburtstag Oma. 14,70 €. Habe fertig.",
    meta: "5er-Bundle · vor 2 Monaten"
  },
  {
    name: "Laura H.",
    tag: "hochzeit",
    tagLabel: "Hochzeit",
    text: "Hab mir die Designs erst nach Anlass ausgesucht, als ich sie brauchte. Genial. Kein „du musst jetzt entscheiden“-Stress.",
    meta: "3er-Bundle · vorgestern"
  },
  {
    name: "Jana T.",
    tag: "taufe",
    tagLabel: "Taufe",
    text: "Die Patentante meiner Nichte hängt es im Babyzimmer auf — Tauben über dem Wickeltisch. Sie hat angerufen und gefragt, woher das Bild stammt. Aus dem Drucker.",
    meta: "Taufe-Kreuz · für die Nichte · 5 Tage alt"
  },
  {
    name: "Sophie L.",
    tag: "kommunion",
    tagLabel: "Kommunion",
    text: "Bin nicht religiös, das Patenkind aber. Die Aquarell-Taube war neutral genug, dass ich mich auch wohlfühl mit dem Schenken. Wirkte wertvoller als die 80 € drin.",
    meta: "Kommunion-Taube · vor einem Monat"
  },
  {
    name: "Caro P.",
    tag: "hochzeit",
    tagLabel: "Hochzeit",
    text: "Eheringe-Motiv für die Hochzeit meiner besten Freundin. Sie hat das Bild noch am gleichen Abend ins Wohnzimmer gestellt — neben den Eheringen aus echtem Gold. Doppeltes Wow stimmt.",
    meta: "Eheringe · für die beste Freundin · 6 Wochen alt"
  },
  {
    name: "Tina S.",
    tag: "konfirmation",
    tagLabel: "Konfirmation",
    text: "Mein Patenkind hat 7 Karten bekommen und 2 Geschenkkörbe. Mein Wunscherfüller war das einzige, was sie auf Instagram fotografiert hat. Hashtag #aufmerksamtante 😅",
    meta: "Konfirmation-Kreuz · für die Patentochter · 2 Monate alt"
  }
];



